import { Pipe, PipeTransform } from '@angular/core';

export const EMPTSTRING = '';

@Pipe({
  name: 'capitalizeAppStore'
})
export class CapitalizeAppStorePipe implements PipeTransform {
  transform(value: string): any {
    if (value && value.length > 0) {
      if (value.toLowerCase() == 'ios') {
        return 'iOS';
      }
      return 'Android';
    } else {
      return EMPTSTRING;
    }
  }
}
